if (!customElements.get("drawer-element")) {
  customElements.define(
    "drawer-element",
    class DrawerElement extends HTMLElement {
      constructor() {
        super();
        this.drawer = this.querySelector("drawer");
        this.overlay = this.querySelector(".js-overlay");
        this.keepHeader = false

        this.bindEvents();

        this.animationDuration = parseInt(this.dataset.animationDuration) || 700;

        this.querySelectorAll('summary[type="accordion"]').forEach((accordion) => {
          accordion.nextElementSibling.style.height = "0px";
          accordion.nextElementSibling.style.overflow = "hidden";
        });
      }

      bindEvents() {
        this.triggers = document.querySelectorAll(
          `drawer-trigger[data-target="${this.id}"]`
        );
        this.innerDrawerTitles = document.querySelectorAll('.selected-inner-drawer');

        this.triggers.forEach((trigger) =>
          trigger.addEventListener("click", () => {
            if(this.dataset.open === 'true') {
              this.innerDrawerTitles.forEach((title) => { title.innerText = '' })
              this.closeDrawer()
            } else {
              if (trigger.innerText) this.innerDrawerTitles.forEach((title) => { title.innerText = trigger.innerText })
                this.openDrawer()
            }
          })
        )
      }

      onKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        if(this.dataset.open === 'true') {
          this.closeDrawer()
        }
      }

      openDrawer() {
        if (this.dataset.open === 'true') {
          return;
        }
        if(this.dataset.lockScroll !== 'false' && this.parentNode.closest('drawer-component') === null) {
          lockScrollForThis(this)
          this.style.pointerEvents = "";

          // keep header for ssearchdrawer
          if(this.keepHeader) {
            document.querySelector('body').style.top = '0'
          }
        }

        this.dataset.open = 'true'
        this.classList.remove('hidden')
        if (this.id === "cart-drawer") {
          this.drawer.classList.replace('overflow-y-scroll', 'overflow-y-hidden')
          this.drawer.classList.replace('lg:overflow-y-scroll', 'lg:overflow-y-hidden')
        }
        if(this.parentNode.closest('drawer-component')) {
          this.parentNode.closest('drawer-component').drawer.scrollTop = 0
          this.parentNode.closest('drawer-component').drawer.classList.replace('overflow-y-scroll', 'overflow-y-hidden')
        }
        this.whenDrawerIsOpening()

        const header = document.querySelector("header-element");
        if (header.header?.classList.contains("sticky") && !this.keepHeader) {
          header.header.classList.remove('sticky');
        }

        this.openDrawerAnimation()
          .then(() => {
            if(this.parentNode.closest('drawer-component')) {
              this.parentNode.closest('drawer-component').drawer.scrollTop = 0
              this.parentNode.closest('drawer-component').drawer.classList.replace('overflow-y-scroll', 'overflow-y-hidden')
            }
          })
          .then(this.afterDrawerOpened.bind(this));
      }

      closeDrawer() {
        if (this.dataset.open !== 'true') {
          return;
        }
        this.dataset.open = 'false'

        this.whenDrawerIsClosing()

        if(this.dataset.lockScroll !== 'false' && this.parentNode.closest('drawer-component') === null) {
          unlockScrollForThis(this)
        }

        if (this.parentNode.closest('drawer-component')) {
          this.parentNode.closest('drawer-component').drawer.classList.replace('overflow-y-hidden', 'overflow-y-scroll')
        }

        this.closeDrawerAnimation().then(() => {
          this.classList.add('hidden')

          this.afterDrawerClosed()?.bind(this);
          this.style.pointerEvents = "";
        })
      }

      onFocusOut(event) {
        setTimeout(() => {
          if (this.dataset.open === 'true')
            this.closeDrawer();
        });
      }

  afterDrawerOpened() {}

  afterDrawerClosed() {}

  whenDrawerIsOpening() {}

  whenDrawerIsClosing() {}

      async openDrawerAnimation() {
        const drawer = this.querySelector("drawer");
        const overlay = this.querySelector(".js-overlay");

        setTimeout(() => {
          if (drawer.dataset.removeToOpen != "") {
            drawer.classList.remove(...drawer.dataset.removeToOpen.split(" "));
          }
        }, 1);

        if(!overlay) {
          return
        }

        const options = {
          duration: this.animationDuration,
          easing: "cubic-bezier(0,1,0,1)",
          fill: "forwards",
        };

        this.animation = overlay?.animate(
          [{ opacity: 0 }, { opacity: 0.7 }],
          options
        );
        return this.animation?.finished;
      }

      async closeDrawerAnimation() {
        this.style.pointerEvents = "none";

        const drawer = this.querySelector("drawer");
        const overlay = this.querySelector(".js-overlay");

        setTimeout(() => {
          if (drawer.dataset.removeToOpen != "") {
            drawer.classList.add(...drawer.dataset.removeToOpen.split(" "));
          }
        })

        if(!overlay) {
          return
        }

        this.animation?.pause();

        if (this.animation) {
          const timing = this.animation.effect.getComputedTiming();
          const activeDuration = timing.activeDuration;
          const activeProgress = timing.progress;

          this.animationDuration -= activeDuration - activeProgress * activeDuration;
        }

        this.animation?.cancel();

        const options = {
          duration: this.animationDuration,
          easing: "cubic-bezier(0,1,0,1)",
          fill: "forwards",
        };

        this.animation = overlay?.animate(
          [{ opacity: 0.7 }, { opacity: 0 }],
          options
        );
        return this.animation?.finished;
      }
    }
  );
}
